export default {
  prefix: 'vehfixle_',
  geoLocationPermissionGiven: 'geoLocationPermissionGiven',
  authToken: 'authToken',
  uc: 'uc',
  vendorLeadByServiceId: 'vendorLeadByServiceId',
  reservedKeys: ['vehfixle_apiHost', 'vehfixle_devModeEnabled'],
};
